const passwordRequirements = ['required', 'string', 'min:8', 'regex:/([^a-zA-Z\\d])+([a-zA-Z\\d])+|([a-zA-Z\\d])+([^a-zA-Z\\d])+/'];

const daysOfWeek = [
    {
        id: 0,
        name: 'Sunday'
    }, {
        id: 1, 
        name: 'Monday'
    }, 
    {
        id: 2,
        name: 'Tuesday'
    }, {
        id: 3,
        name: 'Wednesday'
    }, {
        id: 4,
        name: 'Thursday'
    }, 
    { 
        id: 5,
        name: 'Friday'
    }, 
    {
        id: 6,
        name: 'Saturday'
    }];

export {
    passwordRequirements,
    daysOfWeek
}